<template>
    <v-row>
        <Loader v-if="loader"></Loader>
        <v-col cols="12">
            <v-card flat>
                <v-card-text>
                    <v-col class="mx-auto" cols="12" sm="6">
                        <v-form ref="form" v-on:submit.prevent="SavePost">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field :rules="[requireRule]" v-model="title" hide-details label="عنوان"
                                        placeholder=" " dense outlined>
                                        <template #label>
                                            عنوان <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field :rules="[requireRule]" v-model="desc" hide-details
                                        label="توضیحات کوتاه" placeholder=" " dense outlined>
                                        <template #label>
                                            توضیحات کوتاه <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete @change="getCategory" :items="lang_items" :rules="[requireRule]" v-model="langSelected"
                                        hide-details label="انتخاب زبان" placeholder=" " dense outlined>
                                        <template #label>
                                            انتخاب زبان<span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete :items="items" item-text="name" item-value="_id"
                                        :rules="[requireRule]" v-model="category" hide-details label="نام محصول"
                                        placeholder=" " dense outlined>
                                        <template #label>
                                            دسته بندی محصول <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12">
                                    <!-- <v-textarea :rules="[requireRule]" v-model="text" hide-details label="متن"
                                        placeholder=" " dense outlined>
                                        <template #label>
                                             متن <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-textarea> -->
                                    <ckeditor :editor="editor" v-model="text" :config="editorConfig"></ckeditor>
                                </v-col>
                                <v-col class="mt-3" cols="12">
                                    <BoxImages ref="fileManager" @uploadDone="getImgUrl" />
                                    <!-- @setImgUrl="getImgUrl" -->
                                    <v-btn @click="$refs.fileManager.dialog = true" width="100%" v-bind="attrs" v-on="on">
                                        انتخاب عکس
                                    </v-btn>
                                    <v-card>
                                        <v-img class="ma-3 text-center mx-auto" width="200" v-if="image" :src="$BaseUrl+image"></v-img>
                                    </v-card>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn width="100%" height="40" class="white--text" depressed color="#02c9b7"
                                        type="submit">ذخیره</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import BoxImages from '../../components/Images.vue'
    export default {
        props: ['post_id'],
        data() {
            return {
                name: '',
                loader: false,
                map: null,
                tileLayer: null,
                mapMarkers: [],
                editor: ClassicEditor,
                editorData: '<p>Content of the editor.</p>',
                editorConfig: {},
                title: '',
                text: '',
                desc: '',
                category: '',
                items: [],
                imgPath2: '',
                image: '',
                image2: '',
                type: '',
                layers: [{
                    id: 0,
                    name: 'Requests',
                    active: true,
                    features: [],
                }, ],
                lang_items: [{
                    text: 'فارسی',
                    value: 'fa'
                }, {
                    text: 'انگلیسی',
                    value: 'en'
                }],
                langSelected:'fa',
                
            }
        },
        components: {
            BoxImages
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill
            }
        },
        mounted() {
            console.log('this is current quill instance object', this.editor)
        },
        created() {
            if (this.post_id) {
                this.getPost()
            }
            this.getCategory()
        },
        methods: {
            SavePost() {
                var valid = this.$refs.form.validate();
                if (!valid)
                    return;
                this.loader = true
                var method = ''
                var url = ''
                if (this.post_id) {
                    method = 'put'
                    url = '/admin/post/edit/' + this.post_id
                } else {
                    method = 'post'
                    url = '/admin/post/add'
                }
                this.request({
                        method: method,
                        url: url,
                        data: {
                            title: this.title,
                            desc: this.desc,
                            text: this.text,
                            image: this.image,
                            category: this.category,
                            lang:this.langSelected
                        }
                    })
                    .then((response) => {
                        //this.$refs.form.reset();
                        this.$notify({
                            title: 'انجام شد',
                            text: 'با موفقیت انحام شد',
                            group: 'foo',
                            type: 'success',
                        });
                        this.$router.push({
                            name: 'list_post'
                        })
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getPost() {
                this.loader = true
                this.request({
                        method: 'get',
                        url: '/admin/post/single/' + this.post_id,
                    })
                    .then((response) => {
                        this.title = response.data.title,
                            this.image = response.data.image,
                            this.category = response.data.category._id,
                            this.text = response.data.text,
                            this.desc = response.data.desc,
                            this.langSelected=response.data.lang
                            this.getCategory()
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getCategory() {
                this.loader = true
                this.request({
                        method: 'get',
                        url: '/admin/category/blog/select?lang='+this.langSelected
                    })
                    .then((response) => {
                        this.items = response.data
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getImgUrl(e) {
                this.image = e
            },
            onEditorBlur(quill) {
                console.log('editor blur!', quill)
            },
            onEditorFocus(quill) {
                console.log('editor focus!', quill)
            },
            onEditorReady(quill) {
                console.log('editor ready!', quill)
            },
            onEditorChange({
                quill,
                html,
                text
            }) {
                console.log('editor change!', quill, html, text)
                this.text = html
            }
        }
    }
</script>

<style>
</style>